// extracted by mini-css-extract-plugin
export var completionBody = "_j7-2";
export var completionCard = "_j7-0";
export var completionFooter = "_j7-3";
export var completionTitle = "_j7-1";